import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dabfcaaa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "popup" }
const _hoisted_2 = { class: "popup-content" }
const _hoisted_3 = { class: "popup-text" }
const _hoisted_4 = { class: "popup-title" }
const _hoisted_5 = { class: "popup-subtitle" }
const _hoisted_6 = { class: "popup-information" }
const _hoisted_7 = { class: "info" }
const _hoisted_8 = { class: "title-name" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "value" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Carconnex NV")
], -1))
const _hoisted_10 = { class: "info" }
const _hoisted_11 = { class: "title-name" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "value" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Grijpenlaan 19, 3300 Tienen, Belgium")
], -1))
const _hoisted_13 = { class: "info" }
const _hoisted_14 = { class: "title-name" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "value" }, [
  /*#__PURE__*/_createElementVNode("span", null, "IBAN BE88 0014 0617 4341")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title-name" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "SWIFT:")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "value" }, [
    /*#__PURE__*/_createElementVNode("span", null, "GEBABEBB08A")
  ])
], -1))
const _hoisted_17 = {
  key: 0,
  class: "popup-info"
}
const _hoisted_18 = { class: "button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_app_format_currency = _resolveComponent("app-format-currency")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: "/img/close-btn.svg",
        class: "modal__close",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closePopup && _ctx.closePopup(...args)))
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_i18n_t, { keypath: "dashboard.manualTransferInfo.title" })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_i18n_t, { keypath: "dashboard.manualTransferInfo.manualTransferDescription" })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("strong", null, [
                _createVNode(_component_i18n_t, { keypath: "dashboard.manualTransferInfo.transferTo" })
              ])
            ]),
            _hoisted_9
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("strong", null, [
                _createVNode(_component_i18n_t, { keypath: "dashboard.manualTransferInfo.address" })
              ])
            ]),
            _hoisted_12
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("strong", null, [
                _createVNode(_component_i18n_t, { keypath: "dashboard.manualTransferInfo.bankAccount" })
              ])
            ]),
            _hoisted_15
          ]),
          _hoisted_16
        ]),
        (!!_ctx.paymentDto?.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("table", null, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, [
                      _createVNode(_component_i18n_t, { keypath: "dashboard.manualTransferInfo.reference" })
                    ]),
                    _createElementVNode("th", null, [
                      _createVNode(_component_i18n_t, { keypath: "dashboard.manualTransferInfo.totalAmount" })
                    ])
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentDto, (payment) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: payment.id
                    }, [
                      _createElementVNode("td", null, _toDisplayString(payment.reference), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_app_format_currency, {
                          value: payment.total_amount_euro,
                          currency: "EUR"
                        }, null, 8, ["value"])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("button", {
          class: "button-text ok-button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closePopup && _ctx.closePopup(...args)))
        }, "OK")
      ])
    ])
  ]))
}